module.exports = __webpack_public_path__ + "static/media/photo-slider-1.253f9056.png";